import * as Yup from 'yup';

export const tubeListSchema = Yup.object({
  Description: Yup.string().required('Description is required'),
});
